import { ExceptionService } from '../services/exception.service';
import { NodeAPIService } from '../services/node.api.service';
import {
  Component, Input, Output, EventEmitter, AfterContentChecked,
  ChangeDetectorRef, OnInit, ElementRef
} from '@angular/core';
import {
  UntypedFormGroup, UntypedFormBuilder, UntypedFormControl,
  Validators, ValidatorFn, AbstractControl
} from '@angular/forms';
import { TogetherDIPStageContainer } from './../models/app.models';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  TogetherAuctionDIPLoanDetails,
  TogetherAuctionDIPSecurityDetails
} from './../models/api.models';
import {
  TogetherAuctionDIPEntityType,
  TogetherAuctionDIPEntityOperation
} from './../models/enums';
import { NodeAPIEntityService } from './../services/node.entity.service';
import * as _ from 'lodash-es';
import moment from 'moment';
import { DipStateService } from '../services/dip-state-service.service';

/**
 *
 * class to handle additional loan detail screen transactions
 * @export
 * @class TogetherAuctionDIPAdditionalDetailsComponent
 */
@Component({
    selector: 'together-auction-dip-additional-details',
    templateUrl: './dip.additional_details.component.html',
    standalone: false
})
export class TogetherAuctionDIPAdditionalDetailsComponent {
  additionalLoanDetailsForm: UntypedFormGroup;
  loan_details: TogetherAuctionDIPLoanDetails;
  securities: TogetherAuctionDIPSecurityDetails[] = [];
  securities_response: Array<object>;
  @Input() is_dip: string;
  @Input() property_type: any;
  @Input() stage: TogetherDIPStageContainer;
  @Input() incoming_case_id: string;
  @Output() stage_changing = new EventEmitter();
  _forwardText: string = 'Solicitor\'s details';
  _actionText: string = 'Add additional property';
  _showAction: boolean;
  _showForward: boolean = true;
  _showBackward: boolean = false;
  _isLoading: boolean = false;
  _do_save: boolean = false;
  isSubmitted: boolean = false;

  getSecurity: BehaviorSubject<any> = new BehaviorSubject(false);

  isAdditionalSecuritySelected: boolean = false;

  isDipJourney: boolean;
  propertyType: number;

  showBackward() {
    return this.isDipJourney === false;
  }

  showAction() {
    return this.isDipJourney === false;
  }

  tad_property_value: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
  ]);
  tad_loan_amount: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.min(26000),
    Validators.max(3000000),
    Validators.minLength(5),
    Validators.maxLength(7),
  ]);
  tad_loan_intended_repayment: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
  ]);
  tad_loan_required_day: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.min(1),
    Validators.max(31),
  ]);
  tad_loan_required_month: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.min(1),
    Validators.max(12),
  ]);
  tad_loan_required_year: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
  ]);
  tad_additional_securities_display: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
  ]);

  additionalSecurityForm: UntypedFormGroup = this.fb.group({});

  get hasMultipleProperties() {
    return this.tad_additional_securities_display.value === true ||
      this.tad_additional_securities_display.value === 'true';
  }

  /**
   *
   * @readonly
   * @memberof AddressComponent
  */
  get tad_Security_store() {
    return this.additionalLoanDetailsForm.get('additionalSecurityForm');
  }

  /**
  * @memberof AddressComponent
  */
  set tad_Security_store(val) {
    let value = val;
    if (val instanceof UntypedFormGroup) {
      value = val.value;
    }
    this.additionalLoanDetailsForm.get('additionalSecurityForm').setValue(value);
  }

  /**
   *
   *
   * @param {any} form
   * @memberof TogetherAuctionDIPAdditionalDetailsComponent
   */
  _handleSecurityForm(form) {
    this.additionalLoanDetailsForm.setControl('additionalSecurityForm', form);
  }

  /**
   *
   *
   * @returns
   * @memberof TogetherAuctionDIPAdditionalDetailsComponent
   */
  formValuesValid() {
    var self = this;
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const la = group.controls['tad_loan_amount'].value;
      const pv = group.controls['tad_property_value'].value;

      const _day = group.controls['tad_loan_required_day'];
      const _month = group.controls['tad_loan_required_month'];
      const _year = group.controls['tad_loan_required_year'];

      const day = _day.value;
      const month = _month.value;
      const year = _year.value;

      const errors = {};
      const dateY = year + ' ' + month + ' ' + day;
      const is_date_valid = moment(dateY, 'YYYY MM DD');
      const date_cutoff_ceil = moment().add({ days: 1 });
      let future = moment().add({ months: 3 });

      const each_valid = [_.isNil(day) === false,
      _.isNil(month) === false, _.isNil(year) === false];
      const values_updated = _.includes(each_valid, true);
      const all_values_set = each_valid.every(p => p === true);

      if (la > pv) {
        errors['loanValueLess'] = true;
      }


      if (_day.valid && _month.valid && _year.valid) {
        if (is_date_valid.isValid() === false && all_values_set) {
          errors['dateInvalid'] = true;
        }
        if (is_date_valid.isBefore(date_cutoff_ceil, 'day') && all_values_set) {
          errors['tooFarInPast'] = true;
        }
        if (is_date_valid.isAfter(future, 'day')) {
          errors['tooFarInFuture'] = true;
        }
      }

      if (_.isEmpty(errors)) {
        return null;
      }

      return errors;
    };
  }


  _handleForward() {
    this.isSubmitted = true;
    if (this.additionalLoanDetailsForm.valid) {
      this._isLoading = true;
      this._saveLoanDetails();
    } else {
      this.validateAllFormFields(this.additionalLoanDetailsForm);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    const self = this;       //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (field === 'tad_additional_securities_display') {
        this.isAdditionalSecuritySelected = true;
      }
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  _handleBackWard() {
    this.stage_changing.emit(this.stage.backward_stage.reference);
  }

  _handleAction() {
    this._do_save = true;
  }
  _handleLoading(status) {
    this._isLoading = status;
  }

  _setLoanDefaults() {
    if (!_.isNil(this.loan_details)) {
      this.tad_loan_amount.setValue(this.loan_details.LoanAmount);
      this.tad_property_value.setValue(this.loan_details.PropertyValuation);

      if (_.isNil(this.loan_details.DateLoanRequired) === false &&
        _.isEmpty(this.loan_details.DateLoanRequired) === false) {
        const tad_date = new Date(this.loan_details.DateLoanRequired);
        this.tad_loan_required_day.setValue(tad_date.getDate());
        this.tad_loan_required_month.setValue(tad_date.getMonth() + 1);
        this.tad_loan_required_year.setValue(tad_date.getFullYear());
      }
      this.tad_loan_intended_repayment.setValue(this.loan_details.RepaymentStrategy === 0 ?
        null : _.toString(this.loan_details.RepaymentStrategy));
    }
  }


  _getSecurityDetails() {
    var self = this
    this.api.getPropertyDetails(this.incoming_case_id)
      .subscribe(
        (success) => {
          try {
            const obj = (success as any); //JSON.parse(success.text());

            // The first array item is the primary, which we do not want.
            if (obj.length > 1) {
              _.reverse(obj);
              obj.pop();
              const security =
                obj.map(resp => new TogetherAuctionDIPSecurityDetails(resp));
              this.securities = security;
              this.tad_additional_securities_display.setValue('true');
              this._showAction = true;
            } else {
              this.securities[0] =
                new TogetherAuctionDIPSecurityDetails();
              if (!_.isNil(self.loan_details) &&
                _.isEmpty(self.loan_details.DateLoanRequired) === false) {
                this.tad_additional_securities_display.setValue('false');
                this._showAction = false;
              }
            }
            self._prepareLoanDetails();
          } catch (JSONParseError) {
            this.exception.haveReceivedError(JSONParseError);
          }
        },
        (error) => {
          this.exception.haveReceivedError(error);
          return;
        },
      );
  }

  _handleMoveForward() {
    if (this.hasMultipleProperties === false) {
      this.stage_changing.emit(this.stage.current_stage.forward_reference);
    }
  }

  _getLoanDetails() {
    this.api.getLoanDetails(this.incoming_case_id)
      .subscribe(
        (success) => {
          try {
            const obj = (success as any); //JSON.parse(success.text());
            this.loan_details = new TogetherAuctionDIPLoanDetails(obj);
            this._setLoanDefaults();
            this.getSecurity.next(true);

          } catch (JSONParseError) {
            this._isLoading = false;
            this.exception.haveReceivedError(JSONParseError);
          }
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
          return;
        },
      );
  }



  _handleSaveProperties() {
    if (this.hasMultipleProperties) {
      this._do_save = true;
      this._isLoading = true;
    } else {
      this._handleMoveForward();
    }
  }

  _saveLoanDetails() {
    this.api.saveLoanDetails(this.loan_details)
      .subscribe(
        (success) => {
          try {
            const obj = (success as any); //JSON.parse(success.text());
            this.loan_details = new TogetherAuctionDIPLoanDetails(obj);
            this._isLoading = false;
            this._setLoanDefaults();
            this._handleSaveProperties();
          } catch (JSONParseError) {
            this._isLoading = false;
            return;
          }
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
        },
      );
  }

  /**
  *
  *
  * @memberof TogetherAuctionDIPAdditionalDetailsComponent
  */
  deleteSecurity() {
    if (!_.isEmpty(this.securities) && !_.isNil(this.securities[0].caseSecurityRequest) &&
      this.api.isNew(this.securities[0].caseSecurityRequest.Id) === false) {
      this._isLoading = true;
      this.entity.deleteEntities(TogetherAuctionDIPEntityType.SecurityDetails,
        this.incoming_case_id,
        this.securities[0].caseSecurityRequest.Id, null)
        .subscribe(
          (success) => {
            try {
              this._isLoading = false;
              // tslint:disable-next-line:variable-name
            } catch (JSONParseError) {
              return;
            }
          },
          (error) => {
            this.exception.haveReceivedError(error);
          },
        );
    }
    this.securities = [];
  }


  /**
   * Prepare loan details page.
   *
   * @memberof TogetherAuctionDIPAdditionalDetailsComponent
   */
  _prepareLoanDetails() {
    if (!_.isNil(this.loan_details)) {
      this.loan_details.LoanAmount = this.tad_loan_amount.value;
      this.loan_details.RepaymentStrategy =
        _.toInteger(this.tad_loan_intended_repayment.value);
      this.loan_details.PropertyValuation = this.tad_property_value.value;
      if (_.isNil(this.tad_loan_required_year.value) ||
        _.isNil(this.tad_loan_required_day.value) ||
        _.isNil(this.tad_loan_required_month.value)) return;
      const date = new Date(_.toInteger(this.tad_loan_required_year.value),
        _.toInteger(this.tad_loan_required_month.value) - 1,
        _.toInteger(this.tad_loan_required_day.value));
      this.loan_details.DateLoanRequired = date.toISOString();
    }
  }

  handleSave(outcome) {
    this._do_save = false;
    if (outcome) {
      this.stage_changing.emit(this.stage.current_stage.forward_reference);
    }
    this._isLoading = false;
  }


  onChanges() {
    this.additionalLoanDetailsForm.get('tad_additional_securities_display').
      valueChanges.subscribe((val) => {
        this.isAdditionalSecuritySelected = false;
        if (val === 'false') {
          this._showAction = false;
          this.deleteSecurity();
          if (!_.isNil(this.additionalLoanDetailsForm.get('additionalSecurityForm'))) {
            this.additionalLoanDetailsForm.removeControl('additionalSecurityForm');
          }
        } else if (val === 'true') {
          this._showAction = true;
          if (_.isEmpty(this.securities))
            this.securities[0] = new TogetherAuctionDIPSecurityDetails();
        }

        this.ref.detectChanges();
      });

    this.getSecurity.subscribe((val) => {
      if (val) {
        this._getSecurityDetails();
        this._isLoading = false;
      }
    });
  }

  /**
  * Updates the objects.
  *
  * @memberof TogetherAuctionDIPAdditionalDetailsComponent
  */
  ngAfterContentChecked() {
    this._prepareLoanDetails();
  }

  /**
   * Retrieve loan details on init.
   *
   * @memberof TogetherAuctionDIPAdditionalDetailsComponent
   */
  ngOnInit() {
    window.scrollTo(0, 0);
    this._isLoading = true;
    this._getLoanDetails();
    this.onChanges();
  }

  /**
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  setDynamicClasses(control: string) {
    return {
      'is-invalid form-control-danger': this.additionalLoanDetailsForm.get(control).touched
        && this.additionalLoanDetailsForm.get(control).invalid,
      'is-valid form-control-success': this.additionalLoanDetailsForm.get(control).touched
        && this.additionalLoanDetailsForm.get(control).valid,
    };
  }

  /**
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  setDynamicClassesForFormgroup(control: string) {
    return {
      'is-invalid': this.additionalLoanDetailsForm.get(control).touched
        && this.additionalLoanDetailsForm.get(control).invalid,
      'is-valid': this.additionalLoanDetailsForm.get(control).touched
        && this.additionalLoanDetailsForm.get(control).valid,
    };
  }

  _handleFormInit() {
    return this.fb.group({
      tad_property_value: this.tad_property_value,
      tad_loan_amount: this.tad_loan_amount,
      tad_loan_intended_repayment: this.tad_loan_intended_repayment,
      tad_loan_required_day: this.tad_loan_required_day,
      tad_loan_required_month: this.tad_loan_required_month,
      tad_loan_required_year: this.tad_loan_required_year,
      tad_additional_securities_display: this.tad_additional_securities_display,
      additionalSecurityForm: this.additionalSecurityForm,
    }, { validator: this.formValuesValid() });
  }

  ngAfterViewChecked() {
    if (this.isSubmitted) {
      const element = this.elementRef.nativeElement.querySelector('.is-invalid');
      if (!_.isNil(element)) {
        element.scrollIntoView();
        this.isSubmitted = false;
      }
    }
  }

  constructor(private fb: UntypedFormBuilder, private api: NodeAPIService,
    private entity: NodeAPIEntityService,
    private ref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private state: DipStateService,
    private exception: ExceptionService) {
    this.additionalLoanDetailsForm = this._handleFormInit();

    this.isDipJourney = this.state.isDipJourney.getValue();
    this.propertyType = this.state.propertyType.getValue();
  }
}
